import React from "react";
import { Helmet } from "react-helmet";

type PocketflowsAnalyticsScriptProps = {
  embedId?: string | null;
};

function PocketflowsAnalyticsScript(props: PocketflowsAnalyticsScriptProps) {
  const { embedId } = props;
  console.log("loading analytics script for embed ID:", props.embedId);

  if (!embedId) {
    return null;
  }

  return (
    <Helmet>
      <script
        async
        src={`https://api.pocketflows.com/analytics/${embedId}/js`}
      />
    </Helmet>
  );
}

export default PocketflowsAnalyticsScript;
